import { CompanyContact } from './company-contact';
import { SortByDisplayOrder, SortContactsByDisplayOrder } from './sort-by-display-order';

export class CompanyContactsRoleAddressesHelper {
  /**
   * Sorts company contacts by display order BUT set nulls to the end, then by role_desc, then by party_organization_display_name,
   * then by location_desc
   *
   * @param companyContacts - company contacts to be sorted
   * @returns sorted company contacts
   */
  public static SortCompaniesByDisplayOrder(companies: Record<string, any>[]): Record<string, any>[] {
    return SortByDisplayOrder(companies as CompanyContact[]);
  }

  /**
   * Sorts contacts in ascending order by display order, with nulls at the end. When display order is the same,
   * sorts by contact name (use familiar_name, if empty fallback contact_display_name)
   *
   * @param companies
   * @returns
   */
  public static SortContactsByDisplayOrder(companies: Record<string, any>[]): Record<string, any>[] {
    return SortContactsByDisplayOrder(companies as CompanyContact[]);
  }
}
